<template>
  <div class="t-pass-header">
    <div class="t-pass-header-warp">
      <img src="@/assets/images/tp-arrow-left.svg" alt="arrow-left" @click="goBack(routerUrl)" />

      <span class="tp-title">{{ title }}</span>
      <div class="tp-empty"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TPassHeader',

  props: {
    title: {
      type: String,
      default: '',
    },
    routerUrl: {
      type: String,
      default: '',
    },
    isRouterAppView: {
      type: Boolean,
      default: false,
    },
    isRecord: {
      type: Boolean,
      default: false,
    },
    rpPublicNo: {
      type: String,
      default: '',
    },
    rpPublicRandomCode: {
      type: String,
      default: '',
    },
    receiptToken: {
      type: String,
      default: '',
    },
  },

  created() {
    this.token = this.$store.getters['tPassToken/getTPassToke'];
    console.log('Header this.token', this.token);
    console.log('receiptToken ccc-', this.receiptToken);
    console.log('this.$route.fullPath', this.$route.fullPath);
  },

  methods: {
    goBack(url) {
      // console.log('--url--', url);
      // console.log('isRouterAppView', this.isRouterAppView);
      // console.log('receiptToken', this.receiptToken);
      if (this.isRouterAppView) {
        window.location = url;
      } else if (this.rpPublicNo) {
        this.$router.push({
          name: url,
          params: {
            isRecord: this.isRecord,
            rpPublicNo: this.rpPublicNo,
            rpPublicRandomCode: this.rpPublicRandomCode,
            token: this.token,
            receiptToken: this.receiptToken,
          },
        });
      } else if (this.receiptToken) {
        this.$router.push({
          name: url,
          query: { receiptToken: this.receiptToken },
        });
      } else {
        this.$router.push({
          name: url,
          query: { token: this.token },
        });
      }
    },
  },
};
</script>
